export default __webpack_public_path__ + "static/media/menu_icon.dd6f92f1.svg";